var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckRejectReturnBounced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52917 13C3.52917 12.4477 3.97689 12 4.52917 12H30.4163C30.7003 12 30.9709 12.1207 31.1605 12.3321L35.2734 16.915C35.4381 17.0985 35.5292 17.3364 35.5292 17.5829V25C35.5292 25.5523 35.0815 26 34.5292 26H4.52917C3.97689 26 3.52917 25.5523 3.52917 25V13Z",
    stroke: "#20242E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9784 15.8C9.87382 15.8 8.97839 16.5163 8.97839 17.4C8.97839 18.2837 9.87382 19 10.9784 19C12.083 19 12.9784 19.7163 12.9784 20.6C12.9784 21.4837 12.083 22.2 10.9784 22.2M10.9784 15.8C11.7187 15.8 12.365 16.1218 12.7108 16.6M10.9784 15.8V15M10.9784 22.2L10.9784 23M10.9784 22.2C10.2381 22.2 9.59178 21.8782 9.24597 21.4",
    stroke: "#A8B2C8",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5292 12V16C30.5292 16.5523 30.9769 17 31.5292 17H35.5292",
    stroke: "#20242E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5292 17C21.8625 17 16.5292 17 16.5292 17",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5292 21C19.8625 21 16.5292 21 16.5292 21",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.441,
    cy: 26,
    r: 6,
    fill: "#DD7200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.004 26.6851L32.6469 23.4709C32.7991 22.7099 32.217 22 31.441 22C30.665 22 30.083 22.7099 30.2352 23.4709L30.8781 26.6851C30.9147 26.8682 31.0754 27 31.2622 27H31.6199C31.8066 27 31.9674 26.8682 32.004 26.6851Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.441 29C31.3034 29 31.1856 28.9511 31.0878 28.8533C30.99 28.7554 30.941 28.6377 30.941 28.5C30.941 28.3623 30.99 28.2446 31.0878 28.1467C31.1856 28.0489 31.3034 28 31.441 28C31.5787 28 31.6965 28.0489 31.7943 28.1467C31.8921 28.2446 31.941 28.3623 31.941 28.5C31.941 28.6377 31.8921 28.7554 31.7943 28.8533C31.6965 28.9511 31.5787 29 31.441 29Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRejectReturnBounced);
export default __webpack_public_path__ + "static/media/check-reject-return-bounced.4b0bf7adb5968b5a09ad90b420f8c378.svg";
export { ForwardRef as ReactComponent };